export default {
	title: 'Focus points',
	subtitle:
		'List the indicators of success (top targets), constraints and other critical elements that cristallise the overall goal. They can be financial, legal, technical, political, regulatory etc. Well defined, they “balance” quantity with quality. Then click « next ». You can also skip this step',
	no_description: 'No defined focus point',
	context_worse: 'Negative',
	context_best: 'Positive',
}
